import { Button, Group, Modal, Text } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';
import ErrorMessage from '../ErrorMessage';

const ConfirmationModal = ({ show, message, close, confirm, error, loading, children }) => {
  const submitForm = (e) => {
    e.preventDefault();
    confirm(close);
  };

  // While a confirm action is in flight (`loading`), block every dismissal path
  // — overlay click, Escape, header X, and the Close button — so the dialog
  // can't be closed mid-request. Purely a no-op for callers that don't pass
  // `loading`: it stays undefined, so `!loading` keeps Mantine's defaults and
  // the Close button is not disabled.
  const requestClose = () => {
    if (!loading) {
      close();
    }
  };

  return (
    <Modal
      opened={show}
      onClose={requestClose}
      title="Are you sure?"
      closeOnClickOutside={!loading}
      closeOnEscape={!loading}
    >
      <form onSubmit={submitForm}>
        <Text size="sm" c="dimmed" mb="md">{message}</Text>
        {children}
        <Group justify="flex-end" mt="md">
          <Button
            type="button"
            variant="default"
            leftSection={<IconX size={16} />}
            onClick={requestClose}
            disabled={loading}
          >
            Close
          </Button>
          <Button type="submit" leftSection={<IconCheck size={16} />} loading={loading}>
            Confirm
          </Button>
        </Group>
        {error && <ErrorMessage message={error.message} />}
      </form>
    </Modal>
  );
};

export default ConfirmationModal;
